<!-- *ngIf="dataUser?.chat.serviceContracted.integration.partner.id == 8"-->
<!-- <button mat-icon-button (click)="whatsapp()">
  <mat-icon><img src="assets/images/whatsapp_logo.png"/></mat-icon>
</button> -->

<div class="bottom-right-whatsapp-icon" *ngIf="whatsappButton">
  <a href="{{ whatsapp() }}" target="_blank">
    <button
      mat-icon-button
      aria-label="Example icon-button with a heart icon"
      (click)="whatsapp()"
    >
      <img src="assets/images/whatsapp_logo.png" />
    </button>
  </a>
</div>
